import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search-documentazione',
  templateUrl: './search-documentazione.component.html',
  styleUrls: ['./search-documentazione.component.css']
})
export class SearchDocumentazioneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
